module.exports = __webpack_public_path__ + "static/media/open-book.2de643e0.png";